import axios from 'axios';

export default {
  state: {
    rules: [],
    checksLoading: false,
    checks: [],
    rulesSchema: {},
    currentEditingItem: null,
  },
  mutations: {
    setCurrentEditingItem(state, item) {
      state.currentEditingItem = item;
    },
    setRules(state, rules) {
      rules.forEach((rule) => {
        if (!rule._clientID) {
          rule._clientID = crypto.randomUUID();
        }
        if (!rule.display_name) {
          rule.display_name = rule.name;
        }
      });
      state.rules = [...(rules || [])];
    },
    addCheck(state, check) {
      state.checks = [...state.checks, check];
    },
    setChecks(state, checks) {
      state.checks = [...(checks || [])];
    },
    updateCheck(state, params) {
      const foundCheckIdx = state.checks.findIndex(
        (currCheck) => currCheck.id === params.check.id,
      );
      if (foundCheckIdx > -1) {
        state.checks[foundCheckIdx] = {
          ...state.checks[foundCheckIdx],
          ...params.data,
        };
      }
      Object.keys(params.data).forEach((k) => {
        params.check[k] = params.data[k];
      });
    },
    setChecksLoading(state, loading) {
      state.checksLoading = loading;
    },
    setRulesSchema(state, response) {
      state.rulesSchema = response;
    },
  },
  getters: {
    getCurrentEditingItem(state) {
      return state.currentEditingItem;
    },
    getChecks(state) {
      return state.checks;
    },
    getRules(state) {
      return state.rules;
    },
    getRuleIndex: (state) => (ruleToFind) => {
      return state.rules.findIndex(
        (rule) => rule._clientID === ruleToFind._clientID,
      );
    },
    getRulesSchema(state) {
      return state.rulesSchema;
    },
  },
  actions: {
    getConfigRules(context) {
      return axios.get(`/api/config/rules/`).then((response) => {
        context.commit('setRules', response.data.data.rules);
        return context.state.rules;
      });
    },
    getConfigChecks(context) {
      context.commit('setChecksLoading', true);
      return axios.get(`/api/config/checks/`).then((response) => {
        context.commit('setChecks', response.data);
        context.commit('setChecksLoading', false);
        return context.state.checks;
      });
    },
    createCheck(context, check) {
      return axios.post(`/api/config/checks/`, check).then((response) => {
        return response.data.check;
      });
    },
    saveCheck(context, check) {
      return axios
        .put(`/api/config/checks/${check.id}/`, check)
        .then((response) => {
          return response.data.check;
        });
    },
    deleteCheck(context, checkId) {
      return axios.delete(`/api/config/checks/${checkId}`);
    },
    getConfigRulesSchema(context) {
      axios.get(`/api/config/rules/schema/`).then((response) => {
        context.commit('setRulesSchema', response.data);
        return context.state.rulesSchema;
      });
    },
    updateConfigRules({ commit }, rulesObj) {
      rulesObj.rules?.forEach((rule) => {
        delete rule._clientID;
      });
      return axios.put(`/api/config/rules/`, rulesObj).then((response) => {
        commit('setRules', response.data.data.rules);
        return response;
      });
    },
  },
};
